import { render, staticRenderFns } from "./Assetslog.vue?vue&type=template&id=071e2581"
import script from "./Assetslog.vue?vue&type=script&lang=js"
export * from "./Assetslog.vue?vue&type=script&lang=js"
import style0 from "./Assetslog.vue?vue&type=style&index=0&id=071e2581&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports